import React from 'react';
import './about.css';

const About: React.FC = () => {
  return (
    <div className="about-page">
      <section className="about-hero">
        <p className="about-eyebrow">About Us</p>
        <h1>S-Cubus is not just an institute — it is a movement powered by purpose, discipline, and results.</h1>
        <p>
          Every great achievement begins with a spark, and at S-Cubus, that spark is the explosive power of
          &nbsp;<strong>"S."</strong>
        </p>
      </section>

      <section className="about-block">
        <p>
          <strong>"S"</strong> represents the initials of our Founders - Subir Sir &amp; Sarika Ma'am, the visionaries
          who laid the foundation of this institution with a single belief:
        </p>
        <p className="about-highlight">True education transforms not only marks, but mindsets.</p>
      </section>

      <section className="about-philosophy">
        <div className="about-pillars">
          <article className="about-pillar">
            <div className="about-pillar-icon" aria-hidden="true">
              ♥
            </div>
            <h3>Purpose-Driven</h3>
            <p>Meaningful education that builds clarity, confidence, and strong conceptual foundations.</p>
          </article>

          <article className="about-pillar about-pillar--featured">
            <div className="about-pillar-icon" aria-hidden="true">
              ✓
            </div>
            <h3>Discipline-Led</h3>
            <p>
              A structured learning environment that develops focus, consistency, and lifelong learning habits.
            </p>
          </article>

          <article className="about-pillar">
            <div className="about-pillar-icon" aria-hidden="true">
              ★
            </div>
            <h3>Result-Oriented</h3>
            <p>Proven methodologies that translate understanding into consistent academic excellence.</p>
          </article>
        </div>

        <article className="about-philosophy-panel">
          <div className="about-philosophy-copy">
            <p className="about-philosophy-label">OUR PHILOSOPHY</p>
            <h3>समर्पण • सुनिश्चित • सफलता</h3>
            <p className="about-philosophy-sub">Devotion • Assurance • Success</p>
            <div className="about-philosophy-divider" aria-hidden="true" />
            <p className="about-philosophy-text">
              This is the core principle that drives everything we do. We believe <strong>success is inevitable</strong>{' '}
              when dedication, discipline, and determination come together under the right mentorship.
            </p>
          </div>

          <div className="about-philosophy-orbit">
            <div className="about-philosophy-rings">
              <div className="about-philosophy-ring about-philosophy-ring--outer" />
              <div className="about-philosophy-ring about-philosophy-ring--inner" />
              <div className="about-philosophy-core">⚡</div>
            </div>
            <p>Dream + Dedication + Discipline</p>
          </div>
        </article>
      </section>

      <section className="about-block">
        <h2>Our Faculty</h2>
        <p>
          At S-Cubus, our faculty is the backbone of our success. Each educator is highly qualified, experienced, and deeply
          committed to student's growth. Our teachers focus on concept clarity, disciplined learning, and exam-oriented
          preparation, ensuring every student builds a strong academic foundation.
        </p>
        <p>
          With a student-centric approach, regular assessments, and personal mentorship, our faculty doesn't just teach —
          they guide, motivate, and shape future achievers.
        </p>
        <p>
          We still believe that teachers are the key role-players in every student's life. Our own journey stands as proof —
          our gurus illuminated our path with knowledge and values, enabling us to build this institute with purpose and
          integrity.
        </p>
        <h4>
          At S-Cubus, we want every student to have that one guru in life — a mentor they can trust blindly, who becomes the
          foundation of their confidence, clarity, and results.
        </h4>
        <p>As we strongly believe in the eternal truth:</p>
      </section>

      <section className="about-quote">
        <p>गुरु ब्रह्मा, गुरु विष्णु, गुरु देवो महेश्वरः।</p>
        <p>गुरु साक्षात् परं ब्रह्म, तस्मै श्री गुरवे नमः।</p>
      </section>

      <section className="about-block">
        <p className="about-closing">
          At S-Cubus, belief begins with teachers, and reaches parents through results.
          
        </p>
      </section>
    </div>
  );
};

export default About;
